import { useEffect, useState } from 'react';

export const useKeyboardControls = () => {
  const [keys, setKeys] = useState({
    forward: false,
    backward: false,
    left: false,
    right: false,
    jump: false,
    run: false,
    rasengan: false,
    shuriken: false,
  });

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Skip handling if the target is an input field or we're in a modal
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        document.querySelector('[data-modal-active="true"]')
      ) {
        return;
      }

      // Prevent scrolling with these keys
      if (
        [
          'w',
          'a',
          's',
          'd',
          ' ',
          'arrowup',
          'arrowdown',
          'arrowleft',
          'arrowright',
          'r',
          'f',
        ].includes(e.key.toLowerCase())
      ) {
        e.preventDefault();
      }

      switch (e.key.toLowerCase()) {
        case 'w':
        case 'arrowup':
          setKeys((prev) => ({ ...prev, forward: true }));
          break;
        case 's':
        case 'arrowdown':
          setKeys((prev) => ({ ...prev, backward: true }));
          break;
        case 'a':
        case 'arrowleft':
          setKeys((prev) => ({ ...prev, left: true }));
          break;
        case 'd':
        case 'arrowright':
          setKeys((prev) => ({ ...prev, right: true }));
          break;
        case ' ':
          setKeys((prev) => ({ ...prev, jump: true }));
          break;
        case 'shift':
          setKeys((prev) => ({ ...prev, run: true }));
          break;
        case 'r':
          setKeys((prev) => ({ ...prev, rasengan: true }));
          break;
        case 'f':
          setKeys((prev) => ({ ...prev, shuriken: true }));
          break;
      }
    };

    const handleKeyUp = (e: KeyboardEvent) => {
      // Skip handling if the target is an input field or we're in a modal
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement ||
        document.querySelector('[data-modal-active="true"]')
      ) {
        return;
      }

      switch (e.key.toLowerCase()) {
        case 'w':
        case 'arrowup':
          setKeys((prev) => ({ ...prev, forward: false }));
          break;
        case 's':
        case 'arrowdown':
          setKeys((prev) => ({ ...prev, backward: false }));
          break;
        case 'a':
        case 'arrowleft':
          setKeys((prev) => ({ ...prev, left: false }));
          break;
        case 'd':
        case 'arrowright':
          setKeys((prev) => ({ ...prev, right: false }));
          break;
        case ' ':
          setKeys((prev) => ({ ...prev, jump: false }));
          break;
        case 'shift':
          setKeys((prev) => ({ ...prev, run: false }));
          break;
        case 'r':
          setKeys((prev) => ({ ...prev, rasengan: false }));
          break;
        case 'f':
          setKeys((prev) => ({ ...prev, shuriken: false }));
          break;
      }
    };

    // Reset all keys when window loses focus
    const handleBlur = () => {
      setKeys({
        forward: false,
        backward: false,
        left: false,
        right: false,
        jump: false,
        run: false,
        rasengan: false,
        shuriken: false,
      });
    };

    window.addEventListener('keydown', handleKeyDown, { passive: false });
    window.addEventListener('keyup', handleKeyUp);
    window.addEventListener('blur', handleBlur);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('blur', handleBlur);
    };
  }, []);

  return keys;
};
